import styled from "styled-components";
import { colors } from "../../../utils";

const Wrapper
	= styled.div`
		&.container {
			display: flex;
			flex-direction: column;
			width: 100%;
			background-color: ${colors.container.background};
			border: 1px solid ${colors.container.border};
			border-radius: 8px;
			box-shadow: 0px 4px 10px 6px rgba(12, 10, 255, 0.35);
			padding: calc(10px + .8vw) calc(8px + .8vw);
		}
	`

export default Wrapper
